/**
 * Get current user's complete details using Edge Function
 * Returns user_id, organization_id, organization_name, role, and outlets array
 * This replaces separate calls to get-user-role and get-user-outlets
 */

import { supabase } from '../../../lib/supabaseClient';
import { ApiResponse } from '../../../types/api';
import { UserDetailsResponse } from '../../../types';
import { handleEdgeFunctionError } from '../../../utils/edgeFunctionUtils';

export async function getUserDetailsWithEdgeFunction(userId: string): Promise<ApiResponse<UserDetailsResponse>> {
  try {
    const { data, error } = await supabase.functions.invoke('get-user-details', {
      body: { user_id: userId },
    });

    if (error) {
      console.error('[Edge Function Error] getUserDetails:', error);
      const extractedError = await handleEdgeFunctionError(error);
      return { data: null, error: extractedError };
    }

    return { data: data?.data || null, error: data?.error || null };
  } catch (err) {
    console.error('[Edge Function Exception] getUserDetails:', err);
    return { data: null, error: err };
  }
}
